export default __webpack_public_path__ + "static/media/el15.742a8b28.svg";